import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom"
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import { blogs } from "../Blog";
import { FaSearch } from "react-icons/fa";
import Cta from "../Components/Cta";
import SchemaMarkup from "../Components/SchemaMarkup";
import WebPageSchema from "../Schema/WebpageSchema";
import CollectionPageSchema from "../Schema/CollectionPageSchema";
import ItemListSchema from "../Schema/ItemListSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";

const Blog=()=>{
useEffect(() => {
        document.title =
          "WhatsApp Automation & Growth Blog | Onbbits";
    
        const metaDesc = document.querySelector("meta[name='description']");
        if (metaDesc) {
          metaDesc.setAttribute(
            "content",
            "Discover WhatsApp automation tips, lead conversion strategies, and customer support guides to scale your business efficiency with Onbbits."
          );
        }
    
        const canonical = document.querySelector("link[rel='canonical']");
      if (canonical) {
        canonical.setAttribute("href", "https://onbbits.io/blog");
      }
    
      const ogTitle = document.querySelector("meta[property='og:title']");
      if (ogTitle) {
        ogTitle.setAttribute(
          "content",
          "WhatsApp Automation & Growth Blog | Onbbits"
        );
      }
    
        const ogDesc = document.querySelector("meta[property='og:description']");
      if (ogDesc) {
        ogDesc.setAttribute(
          "content",
          "Discover WhatsApp automation tips, lead conversion strategies, and customer support guides to scale your business efficiency with Onbbits."
        );
      }
    
      const ogUrl = document.querySelector("meta[property='og:url']");
      if (ogUrl) {
        ogUrl.setAttribute("content", "https://onbbits.io/blog");
      }
    
        const ogImage = document.querySelector("meta[property='og:image']");
      if (ogImage) {
        ogImage.setAttribute(
          "content",
          "https://onbbits.io/Images/flow-builder.webp"
        );
      }
    
        const twitterTitle = document.querySelector("meta[name='twitter:title']");
      if (twitterTitle) {
        twitterTitle.setAttribute(
          "content",
          "WhatsApp Automation & Growth Blog | Onbbits"
        );
      }
    
        const twitterDesc = document.querySelector(
        "meta[name='twitter:description']"
      );
      if (twitterDesc) {
        twitterDesc.setAttribute(
          "content",
          "Discover WhatsApp automation tips, lead conversion strategies, and customer support guides to scale your business efficiency with Onbbits."
        );
      }
    
        const twitterImage = document.querySelector("meta[name='twitter:image']");
      if (twitterImage) {
        twitterImage.setAttribute(
          "content",
          "https://onbbits.io/Images/flow-builder.webp"
        );
      }
      }, []);

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
    },
  },
};

const buttonAnim = {
  hidden: {
    opacity: 0,
    scale: 0.9,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delay: 0.4,
      duration: 0.5,
    },
  },
};

const navigate = useNavigate();
const location = useLocation();

const [searchTerm, setSearchTerm] = useState("");
const [selectedCategory, setSelectedCategory] = useState("All");
const [appliedSearch, setAppliedSearch] = useState("");

const safeBlogs = Array.isArray(blogs) ? blogs : [];

const BLOGS_PER_PAGE = 6;

const handlePageChange = (newPage) => {
  setCurrentPage(newPage);

  navigate(`/blog?page=${newPage}`, {
    replace: true,
  });

  setTimeout(() => {
    const element = document.getElementById("blog-grid");

    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, 50);
};

const getPageFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  const page = parseInt(params.get("page"), 10);

  return page && page > 0 ? page : 1;
};

const [currentPage, setCurrentPage] = useState(getPageFromUrl);

const categoriesList = ["All"];

safeBlogs.forEach((blog) => {
  if (
    blog?.category &&
    !categoriesList.includes(blog.category)
  ) {
    categoriesList.push(blog.category);
  }
});

useEffect(() => {
  if (location.state) {

    if (location.state.selectCategory) {

      setSelectedCategory(
        location.state.selectCategory
      );

      setSearchTerm("");
      setAppliedSearch("");

    } else if (location.state.searchString) {

      setAppliedSearch(
        location.state.searchString
      );

      setSearchTerm(
        location.state.searchString
      );

      setSelectedCategory("All");
    }

    setTimeout(() => {
      const section =
        document.getElementById("blog-grid");

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
        });
      }
    }, 100);

    window.history.replaceState(
      {},
      document.title
    );
  }
}, [location.state]);

const handleCategoryClick = (category) => {
  setSelectedCategory(category);
  setSearchTerm("");
  setAppliedSearch("");
};

const suggestions = [];

const cleanTerm =
  searchTerm.trim().toLowerCase();

if (cleanTerm !== "") {

  categoriesList.forEach((cat) => {

    if (
      cat !== "All" &&
      cat.toLowerCase().includes(cleanTerm)
    ) {
      suggestions.push({
        type: "category",
        value: cat,
      });
    }
  });

  safeBlogs.forEach((blog) => {

    if (
      blog?.title &&
      blog.title
        .toLowerCase()
        .includes(cleanTerm)
    ) {
      suggestions.push({
        type: "blog",
        value: blog.title,
        slug: blog.slug,
      });
    }
  });
}

const handleKeyDown = (e) => {

  if (e.key === "Enter") {

    if (suggestions.length > 0) {

      const topResult =
        suggestions[0];

      if (
        topResult.type === "category"
      ) {

        setSelectedCategory(
          topResult.value
        );

        setSearchTerm("");

        setAppliedSearch("");

      } else {

        navigate(
          `/blog/${topResult.slug}`
        );
      }

    } else {

      setAppliedSearch(searchTerm);
    }
  }
};

const filteredBlogs =
  safeBlogs.filter((blog) => {

    const matchesCategory =
      selectedCategory === "All" ||
      blog.category === selectedCategory;

    const cleanSearch =
      appliedSearch
        .trim()
        .toLowerCase();

    const matchesSearch =
      cleanSearch === "" ||
      blog.title
        ?.toLowerCase()
        .includes(cleanSearch) ||
      blog.category
        ?.toLowerCase()
        .includes(cleanSearch);

    return (
      matchesCategory &&
      matchesSearch
    );
  });

const totalPages = Math.ceil(
  filteredBlogs.length / BLOGS_PER_PAGE
);

const safeCurrentPage =
  totalPages > 0
    ? Math.min(currentPage, totalPages)
    : 1;

const startIndex =
  (safeCurrentPage - 1) * BLOGS_PER_PAGE;

const paginatedBlogs = filteredBlogs.slice(
  startIndex,
  startIndex + BLOGS_PER_PAGE
);

useEffect(() => {
    if (location.state) {
     if (location.state.selectCategory) {

  setSelectedCategory(location.state.selectCategory);
  setSearchTerm("");
  setAppliedSearch("");
  setCurrentPage(1);

} else if (location.state.searchString) {

  setAppliedSearch(location.state.searchString);
  setSearchTerm(location.state.searchString);
  setSelectedCategory("All");
  setCurrentPage(1);

}
      
      // Smoothly push view into focus right after updating state
      setTimeout(() => {
        const element = document.getElementById("blog-grid");
        if (element) {
          element.scrollIntoView();
        }
      }, 100);

      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  useEffect(() => {
  const page = getPageFromUrl();

  setCurrentPage(page);
}, [location.search]);


    return(
        <>

<SchemaMarkup
  data={WebPageSchema({
    type: "WebPage",
    name: "ONBBITS Blog",
    description:
      "Read the latest ONBBITS articles about WhatsApp Business API, WhatsApp automation, customer engagement, marketing, sales, and business communication.",
    url: "https://onbbits.io/blog"
  })}
/>

<SchemaMarkup
  data={CollectionPageSchema({
    name: "ONBBITS Blog",
    description:
      "Explore ONBBITS blog articles covering WhatsApp Business API, automation, customer engagement, marketing, sales, and business communication.",
    url: "https://onbbits.io/blog"
  })}
/>

<SchemaMarkup
  data={ItemListSchema({
    name: "ONBBITS Blog Articles",
    items: safeBlogs.map((blog) => ({
      name: blog.title,
      url: `https://onbbits.io/blog/${blog.slug}`
    }))
  })}
/>

<SchemaMarkup
  data={BreadcrumbSchema({
    items: [
      {
        name: "Home",
        url: "https://onbbits.io/"
      },
      {
        name: "Blog",
        url: "https://onbbits.io/blog"
      }
    ]
  })}
/>
         {/**BREADCRUMB */}
        <Breadcrumb title="The Ultimate WhatsApp Business Growth & Automation Guide" 
        />

         {/**BLOG CARDS + SIDEBAR */}
   <section className="blog-listing-section">
  <div className="container">

    <div className="blog-layout">

      {/* LEFT */}
      <div className="blog-main"
       id="blog-grid">

        <motion.div
          className="blog-main-heading"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUp}
        >

          <h2 className="section-heading">
           WhatsApp Automation Insights, Tips & <span>Business Growth Strategies</span>
          </h2>

        </motion.div>

     <div
  className={`blog-grid ${
    filteredBlogs.length === 0
      ? "blog-grid-empty"
      : ""
  }`}>

          {filteredBlogs.length === 0 ? (

  <div className="no-blog-found">

    <h3 className="card-heading">
      No Blogs Found
    </h3>

    <p className="section-text">
      No articles match your search.
    </p>

    <button
      className="btn btn-primary reset-btn"
      onClick={() =>
        handleCategoryClick("All")
      }
    >
      Reset Filters
    </button>

  </div>

) : (

  paginatedBlogs.map((blog, index) => (

    <article
      key={index}
      className="products-card"
    >

      <div
        style={{
          overflow: "hidden",
        }}
      >
        <img
          src={blog.img}
          alt={`${blog.title} | Onbbits`}
        />
      </div>

      <div className="blog-card">

        <h3 className="card-heading">
          {blog.title}
        </h3>

        <p className="section-text">
          {blog.desc}
        </p>

         <motion.a
                                  href={`/blog/${blog.slug}`}
                              
                                    className="btn btn-primary"
                                    variants={buttonAnim}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true }}
                                    whileHover={{
                                      scale: 1.05,
                                      y: -2,
                                    }}
                                    whileTap={{
                                      scale: 0.97,
                                    }}
                                  >
                                    Read More
                                  </motion.a>

      </div>

    </article>

  ))
)}
        </div>

{totalPages > 1 && (
  <div className="blog-pagination">

    <button
      className="pagination-btn"
      disabled={safeCurrentPage === 1}
      onClick={() =>
        handlePageChange(safeCurrentPage - 1)
      }
    >
      Previous
    </button>

    <span className="pagination-info">
      Page {safeCurrentPage} of {totalPages}
    </span>

    <button
      className="pagination-btn"
      disabled={safeCurrentPage === totalPages}
      onClick={() =>
        handlePageChange(safeCurrentPage + 1)
      }
    >
      Next
    </button>

  </div>
)}
      </div>

      {/* RIGHT */}
      <aside
        className="blog-sidebar"
      >

        {/* Search */}
        <motion.div
          className="blog-sidebar-box"
          variants={fadeUp}
        >

       <div className="blog-search">

  <input
    type="text"
    placeholder="Search Category / Articles"
    value={searchTerm}
    onChange={(e) =>
      setSearchTerm(e.target.value)
    }
    onKeyDown={handleKeyDown}
  />

  <FaSearch className="blog-search-icon" />

  {suggestions.length > 0 && (

    <div className="blog-search-dropdown">

      {suggestions.map(
        (item, idx) => (

          <div
            key={idx}
            className="blog-search-item"
            onClick={() => {

              if (
                item.type === "category"
              ) {

                handleCategoryClick(
                  item.value
                );

              } else {

                navigate(
                  `/blog/${item.slug}`
                );
              }
            }}
          >
            <span>
              {item.type === "category"
                ? "Category"
                : "Blog"}
            </span>

            {item.value}
          </div>
        )
      )}

    </div>

  )}

</div>

          <h3 className="card-heading">
            Categories
          </h3>

         <ul className="blog-categories">

  {categoriesList.map(
    (item, i) => (

      <li key={i}>

        <button
          className={`blog-category-btn ${
            selectedCategory === item
              ? "active"
              : ""
          }`}
          onClick={() =>
            handleCategoryClick(item)
          }
        >
          {item}
        </button>

      </li>
    )
  )}

</ul>
        </motion.div>

        {/* CTA */}
        <motion.div
          className="blog-sidebar-cta"
          initial={{
            opacity: 0,
            y: 50,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
          }}
          transition={{
            duration: 0.8,
          }}
        >

          <h3 className="card-heading">
            Ready to Automate Your WhatsApp Communication?
          </h3>

          <p className="section-text">
          Automate repetitive messages, manage leads, and streamline customer communication with powerful WhatsApp automation solutions built for business growth.
          </p>

          <ul className="section-text">
            <li>✓ Automated WhatsApp Messages & Replies</li>
            <li>✓ Smart Lead Follow-Ups & Engagement</li>
            <li>✓ Save Time & Grow Your Business Faster</li>
          </ul>

          <motion.a
            href="https://app.onbbits.io/register"
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary"
            variants={buttonAnim}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            whileHover={{
              scale: 1.05,
              y: -2,
            }}
            whileTap={{
              scale: 0.97,
            }}
          >
            Get Started for Free
          </motion.a>

        </motion.div>

      </aside>

    </div>

  </div>
</section>

{/**CTA */}
<Cta />

        </>
    )
}
export default Blog;